import { ReactNode } from "react";
import { Card } from "../../../../components/ui/common/card";

interface FacilitySectionCardProps {
  label: string;
  action?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
}

const FacilitySectionCard = ({ label, action, footer, children }: FacilitySectionCardProps) => (
  <Card className="tw-border-border tw-p-5 tw-space-y-4">
    <div className="tw-flex tw-items-center tw-justify-between tw-gap-3">
      <p className="tw-text-[10px] tw-uppercase tw-tracking-wider tw-text-muted-foreground tw-font-medium">
        {label}
      </p>
      {action}
    </div>
    {children}
    {footer}
  </Card>
);

export default FacilitySectionCard;
